function closePrimarySubmenus(nav) {
  if (!nav) return;
  nav.querySelectorAll(".main-menu > li.is-open").forEach((li) => {
    li.classList.remove("is-open");
    const link = li.querySelector(":scope > a.site-header__menu-parent");
    if (link) link.setAttribute("aria-expanded", "false");
  });
}

function initPrimarySubmenuToggles() {
  const nav = document.querySelector(".site-header__nav");
  if (!nav) return;

  nav
    .querySelectorAll(".main-menu > .menu-item-has-children > a")
    .forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        const li = link.closest("li");
        if (!li || !li.parentElement) return;

        const open = !li.classList.contains("is-open");

        [...li.parentElement.children].forEach((sibling) => {
          if (
            sibling !== li &&
            sibling.classList.contains("menu-item-has-children")
          ) {
            sibling.classList.remove("is-open");
            const siblingLink = sibling.querySelector(
              ":scope > a.site-header__menu-parent",
            );
            if (siblingLink) {
              siblingLink.setAttribute("aria-expanded", "false");
            }
          }
        });

        li.classList.toggle("is-open", open);
        link.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
}

function initPrimaryMenuToggle() {
  const toggle = document.getElementById("primary-menu-toggle");
  const panel = document.querySelector(".site-header__functions");
  const nav = document.querySelector(".site-header__nav");
  if (!toggle || !panel) return;

  const mobileMenu = window.matchMedia("(max-width: 980px)");
  const labelOpen = toggle.dataset.labelOpen || "";
  const labelClose = toggle.dataset.labelClose || "";

  const setOpen = (open) => {
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? labelClose : labelOpen);
    panel.classList.toggle("is-open", open);
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    panel.toggleAttribute("inert", !open);
    if (!open) closePrimarySubmenus(nav);
  };

  toggle.addEventListener("click", () => {
    setOpen(toggle.getAttribute("aria-expanded") !== "true");
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      toggle.getAttribute("aria-expanded") === "true"
    ) {
      setOpen(false);
    }
  });

  const syncMenuAccessibility = () => {
    if (mobileMenu.matches) {
      setOpen(false);
      return;
    }

    panel.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "false");
    panel.removeAttribute("inert");
    closePrimarySubmenus(nav);
  };

  syncMenuAccessibility();
  mobileMenu.addEventListener("change", syncMenuAccessibility);
}

export function initMainMenu() {
  initPrimaryMenuToggle();
  initPrimarySubmenuToggles();
}
